import { AppShellLayout } from './AppShellLayout';

/** Platform super-admin shell — same responsive shell, platform banner forced. */
export function PlatformLayout() {
  return <AppShellLayout platform />;
}
